const ERRORS = {
  CANNOT_CONNECT: 'Cannot connect to the ledger.',
};

export default ERRORS;
